import React from 'react';

interface Props {
  color?: string;
  size?: number;
}

/**
 * 虫眼鏡アイコン（フッターナビ「さがす」）
 * 元SVG offset (-100, -1142) を M 座標に適用済み
 * viewBox: 0 0 20 18
 */
const SearchNavIcon: React.FC<Props> = ({ color = 'currentColor', size = 45 }) => (
  <svg
    viewBox="0 0 20 18"
    width={size}
    height={size}
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      fill={color}
      d="M18.24,16.61l-3.93-3.93c1.04-1.34,1.66-3.01,1.66-4.83,0-4.36-3.55-7.91-7.91-7.91s-7.91,3.55-7.91,7.91,3.55,7.91,7.91,7.91c1.82,0,3.49-.62,4.83-1.66l3.93,3.93c.19.19.44.29.71.29s.52-.1.71-.29c.39-.39.39-1.02,0-1.41ZM8.06,1.94c3.26,0,5.91,2.65,5.91,5.91s-2.65,5.91-5.91,5.91-5.91-2.65-5.91-5.91,2.65-5.91,5.91-5.91Z"
    />
  </svg>
);

export default SearchNavIcon;
